import React from 'react';
import { motion } from 'framer-motion';
import './Footer.css';
import {
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="footer-container"
    >
      <div className="footer-content">

        {/* Brand & About */}
        <motion.div 
          className="footer-section"
          whileHover={{ scale: 1.02 }} 
          transition={{ duration: 0.3 }}
        >
          <h3 className="footer-brand">
            <img 
              src="/images/logo.png" 
              alt="Papadam Logo" 
              className="heroimagee"
            />
          </h3>

          <p className="footer-description">
            Authentische Indische Küche in Pfullendorf nach altbewährten Rezepten
            und mit moderner Leidenschaft zubereitet. Genießen Sie die Gewürze der
            Tradition mit jedem Bissen.
          </p>
        </motion.div>

        {/* Quick Links */}
        <div className="footer-section2">
          <h3 className="footer-heading">MENU</h3>
          <ul className="footer-links">
            <li><a href="/menu">Speisekarte</a></li>
            <li><a href="/about">Über uns</a></li>
            <li><a href="/Booking">Reservierung</a></li>
            <li><a href="/contact">Kontakt</a></li>
            <li><a href="/blog">Blog</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section1">
          <h3 className="footer-heading">Kontakt</h3>

          <ul className="footer-contact">
            <li style={{ color: 'black', marginBottom: '15px', fontWeight: '500', display: 'flex', alignItems: 'center' }}>
              <FaMapMarkerAlt className="contact-icon" style={{ visibility: 'hidden' }} /> {/* Placeholder for alignment */}
              <span>Inhaber: Mahadevi Motty</span>
            </li>
            <li>
              <FaMapMarkerAlt className="contact-icon" />
              <a 
                href="https://www.google.com/maps?q=Hauptstrosso+24,+88630+Pfullendorf"
                target="_blank"
                rel="noopener noreferrer"
                className="address"
              >
                Hauptstraße 24<br />88630 Pfullendorf
              </a>
            </li>

            <li>
              <FaPhone className="contact-icon" />
              <div className="address">
                <a href="tel:+4975523822766">07552 3822 766</a><br />
                <a href="tel:+491722389459">0172 2389 459</a>
              </div>
            </li>

            <li>
              <FaEnvelope className="contact-icon" />
              <a href="mailto:info@papadam-pfullendorf.de" className="address">
                info@papadam-pfullendorf.de
              </a>
            </li>
          </ul>
        </div>

        {/* Opening Hours */}
        <div className="footer-section1">
          <h3 className="footer-heading">Öffnungszeiten</h3>

          <ul className="footer-hours">
            <li>
              <span>Dienstag - Sonntag:</span><br />
              11:00–14:00 Uhr <br />17:00–22:00 Uhr
            </li>
            <li>
              <span>Montag:</span> RUHETAG
            </li>
          </ul>
        </div>
      </div>

      {/* Social Icons */}
      <div className="social-icons-wrapper">
        <div className="social-icons">
          {[
            { 
              icon: FaInstagram, 
              name: 'Instagram', 
              link: 'https://www.instagram.com/papadamindischesrestaurant?igsh=MXg2Y2E0dm9hbTV0aQ==' 
            },
            { 
              icon: FaFacebook, 
              name: 'Facebook', 
              link: 'https://www.facebook.com/share/1CrcvwNBX3/' 
            },
            { 
              icon: FaTwitter, 
              name: 'Twitter', 
              link: '#' 
            }
          ].map((social, idx) => (
            <motion.a
              key={idx}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.name}
              className="social-icon"
              whileHover={{ scale: 1.2, color: '#FFA500' }}
              transition={{ duration: 0.3 }}
            >
              <social.icon />
            </motion.a>
          ))}
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>&copy; {currentYear} Pappadam Küche. Alle Rechte vorbehalten.</p>

        <div className="legal-links">
          <a href="/privacy">Datenschutzrichtlinie</a>
          <a href="/terms">Nutzungsbedingungen</a>
          <a href="/accessibility">Nutzungsbedingungen</a>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
